import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAwards } from '../../api/fetch-awards';

export const fetchAwardsThunk = createAsyncThunk(
    'fetchAwards',
    async () => fetchAwards(),
);
